@if (EssentialObject$ | async; as object) {
<z-modal [open]="true" [host]="this" [dynamicChange]="false" [autoWidth]="true" [autoClose]="false">
    <ng-container footer>
        <a (click)="results.emit({})" class="btn cancel leading-12 rounded text-center px-10">{{"btn_cancel"|
            translate:object.language:ModuleNames.Shared}}</a>
        <i (click)="exportChart()" class="far fa-download btn cancel leading-12 w-12 rounded text-center"></i>
    </ng-container>

    <ng-container body>
        <div class="max-h-screen-90 block bg-white innerListScroll w-export portrait" id="single-chart-export">
            <!-- front page -->
            <!-- <div class="innerPage relative overflow-hidden">
                        <div
                            class="absolute bottom-0 top-0 left-0 right-0 z-50  flex flex-col w-full items-stretch justify-between bg-white p-10">
                            <div class="flex flex-col items-stretch justify-between">
                                <div class="flex flex-row justify-between gap-10">
                                    <h6 class="text-zen text-sm uppercase font-semibold text-opacity-50">
                                        {{ "txtConfidential" | translate }}
                                    </h6>
                         
                                </div>
                                <div class="flex flex-col gap-20">
                                    <div class="mt-12 flex flex-col gap-2 uppercase"
                                        [ngClass]="{'flex-col-reverse': (language | rtl)}">
    
                                        <h1 class="text-zen text-5xl font-medium">
                                            {{ title}}
                                        </h1>
                                        <h5 class="text-zen text-5xl">{{ "txt_report" |
                                            translate }} </h5>
                                    </div>
                                    <div class="flex flex-col gap-2">
                                        <h6 class="text-zen-lite text-xl">{{ "txtfor" |
                                            translate }}</h6>
                                        <h1 class="text-zen text-xl font-semibold">
                                        </h1>
                                        <h5 class="text-zen-lite text-xl">{{date | date: 'dd/MM/yyyy'}}</h5>
                                    </div>
    
                                </div>
                            </div>
                            <div class="flex flex-col gap-1">
                                <p class="text-xs text-zen text-opacity-50">{{"txtPoweredby" |
                                    translate}}</p>
                                <img class="h-10 w-36 object-contain" src="assets/img/logo.png" alt="">
                            </div>
                        </div>
                    </div> -->
            <div class="innerPage block relative px-10 bg-white pt-20">
                <div class="block" [innerHtml]="data.chartHTML.outerHTML | safe"></div>
            </div>

            <!-- <div class="innerPage block bg-white relative">
                        <div class="absolute bottom-0 top-0 left-0 z-30 flex flex-col h-full w-full items-stretch justify-between bg-white p-10"
                            [style.direction]="'ltr'">
                            <div class="flex flex-col items-center gap-5">
                                <img class="h-20 w-auto object-contain mt-40" src="assets/img/logo.png" alt="">
                                <img class="h-10 w-auto object-contain" src="assets/img/tagline.png" alt="">
                                <div class="flex flex-row items-center justify-center gap-1 mt-10">
                                    <i class="fa-regular fa-globe text-zen"></i>
                                    <h6 class="text-zen text-sm">zenithr.com</h6>
                                </div>
                            </div>
                        </div>
                    </div> -->
            <div class="header w-full px-10 flex flex-row items-start justify-between">
                <h5 class="text-3xs text-zen text-opacity-60">{{title
                    |translate }}</h5>
                <h5 class="text-3xs text-zen "><span class="text-opacity-60">{{
                        "txtPreparedFor"|translate:object.language:ModuleNames.Shared }}
                    </span>
                    <span class="text-zen font-medium">{{object.selectedEntity.name |
                        extract:language}}</span>
                </h5>
            </div>
            <div class="footer w-full px-10 flex flex-row items-end justify-between ">
                <div class="flex flex-col gap-1">
                    <img class="h-8 w-auto object-cover" src="assets/img/logo.png" alt="">
                </div>
                <div class="flex flex-col items-end gap-1">
                    <h5 class="text-3xs text-zen text-opacity-60">
                        {{ "txtGeneratedon"|translate:object.language:ModuleNames.Shared }}: {{date | date:
                        'dd/MM/yyyy'}}
                    </h5>
                    <h5 class="text-3xs text-zen text-opacity-60">
                        {{ "txtAllRights"|translate:object.language:ModuleNames.Shared }} © {{date | date: 'yyyy'}}
                        -
                        www.zenithr.com</h5>

                </div>
            </div>

        </div>
    </ng-container>
</z-modal>
}